<template>
  <div class="judge">
    <div class="searchBox">
      <!-- 以下列表为您本次初评所需评选类别，点击任一类别即可进入作品列表进行初评。 -->
      <div style="margin-bottom: 5px;">{{ $t('admin-judge/tip1') }}</div>
      <a-row :gutter="24">
        <a-col
          span="8"
          style="display: flex;"
        >
          <div class="tag">
            {{ $t('admin-profile-product/type') }}
          </div>
          <!-- 类别 -->
          <a-select
            v-model="category_id"
            style="width: 100%;"
            allow-clear
            placeholder="请选择类别"
            @change="changeCate"
          >
            <a-select-option
              v-for="item in cates"
              :key="item.value"
              :value="item.value"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-col>
      </a-row>
    </div>
    <!-- 表格区域 -->
    <a-table
      :columns="columns"
      :data-source="listFilter"
      class="table"
      row-key="value"
      :pagination="false"
      :scroll="{ y: 'calc(100vh - 230px)' }"
    >
      <!-- 序号 -->
      <span slot="index" slot-scope="text,row,index">
        <div>
          {{ index + 1 }}
        </div>
      </span>
      <!-- 总数量 -->
      <span
        slot="num"
        slot-scope="text"
      >
        {{ text }}{{ text > 1 ? $t('admin-judge/pieces') : $t('admin-judge/piece') }}
      </span>
      <!-- 最大推荐数 -->
      <span
        slot="max_recommend"
        slot-scope="text"
      >
        {{ text || 0 }}
      </span>
      <!-- 已经初评数量 -->
      <span
        slot="review_num"
        slot-scope="text"
      >
        {{ text }}{{ text > 1 ? $t('admin-judge/pieces') : $t('admin-judge/piece') }}
      </span>
      <!-- 已推荐数量 -->
      <span
        slot="recommend_num"
        slot-scope="text"
      >
        {{ text }}{{ text > 1 ? $t('admin-judge/pieces') : $t('admin-judge/piece') }}
      </span>
      <!-- 未推荐数量 -->
      <span
        slot="not_recommend_num"
        slot-scope="text"
      >
        {{ text }}{{ text > 1 ? $t('admin-judge/pieces') : $t('admin-judge/piece') }}
      </span>
      <!-- 操作 -->
      <span
        slot="operation"
        slot-scope="text"
      >
        <!-- <a-button type="primary" size="small" @click="goList(text)">{{ $t('admin-judge/awards') }}</a-button> -->
        <a-button type="primary" size="small" @click="goList(text)">初评</a-button>
      </span>
    </a-table>
    <div style="height: 30px;" />
  </div>
</template>
<script>
import { reviewsIndexBefore, reviewsPrimary } from '@/api/judge'
import { getPageKey, setPageKey } from '@/utils/auth'

const columns = [
  {
    title: '序号',
    dataIndex: 'index',
    scopedSlots: { customRender: 'index' },
    width: '70px'
  },
  {
    title: '类别',
    dataIndex: 'name'
  },
  {
    title: '总数量',
    dataIndex: 'num',
    scopedSlots: { customRender: 'num' }
  },
  {
    title: '最大推荐数',
    dataIndex: 'max_num',
    scopedSlots: { customRender: 'max_recommend' }
  },
  {
    title: '已评数量',
    dataIndex: 'review_num',
    scopedSlots: { customRender: 'review_num' }
  },
  {
    title: '已推荐',
    dataIndex: 'recommend_num',
    scopedSlots: { customRender: 'recommend_num' }
  },
  {
    title: '未推荐',
    dataIndex: 'not_recommend_num',
    scopedSlots: { customRender: 'not_recommend_num' }
  },
  {
    title: '操作',
    dataIndex: 'value',
    width: '100px',
    scopedSlots: { customRender: 'operation' }
  }
]

export default {
  data() {
    return {
      columns,
      list: [],
      cates: [], // 类别
      category_id: '' // 你选择的类别信息
    }
  },
  computed: {
    locale() {
      return this.$i18n.locale
    },
    listFilter() {
      return this.list.filter(i => {
        return !this.category_id || this.category_id === '' ? true : this.category_id === i.value
      })
    },
    user() {
      return this.$store.getters.user
    }
  },
  watch: {
    locale(e) {
      this.columns[0].title = this.$t('admin-judge/index')
      this.columns[1].title = this.$t('admin-profile-product/type')
      this.columns[2].title = this.$t('admin-judge/quantity')
      this.columns[3].title = this.$t('admin-judge/maxRecommend')
      this.columns[4].title = this.$t('admin-judge/hasAmount')
      this.columns[5].title = '已推荐'
      this.columns[6].title = '未推荐'
      this.columns[7].title = this.$t('admin-products-products/operating')
    }
  },
  created() {
    this.columns[0].title = this.$t('admin-judge/index')
    this.columns[1].title = this.$t('admin-profile-product/type')
    this.columns[2].title = this.$t('admin-judge/quantity')
    this.columns[3].title = this.$t('admin-judge/maxRecommend')
    this.columns[4].title = this.$t('admin-judge/hasAmount')
    this.columns[5].title = '已推荐'
    this.columns[6].title = '未推荐'
    this.columns[7].title = this.$t('admin-products-products/operating')

    reviewsIndexBefore(1).then(res => {
      this.cates = res.cates
    })

    this.getList()

    // const id = localStorage.getItem('judgeId')
    // if (this.user.role === 3 && id) {
    //   const user_id = this.user.id
    //   const that = this
    //   this.$confirm({
    //     title: '',
    //     content: '您有一项初评工作正在进行，是否返回继续操作。',
    //     okText: '确认',
    //     cancelText: '取消',
    //     onOk() {
    //       that.$router.push({ path: '/admin/judgeDetail', query: { id: id, user_id: user_id }})
    //     },
    //     onCancel() {
    //     }
    //   })
    // }

    let params = getPageKey('judgeIndex')
    if (params) {
      params = JSON.parse(params)
      setTimeout(() => {
        if (params.category_id) this.category_id = Number(params.category_id)
      }, 300)
    }
  },
  methods: {
    getList() {
      // 使用 /reviews/primary 接口获取数据
      reviewsPrimary().then(res => {
        console.log('res', res)
        this.list = res.lists || [] // 表格信息
        if (this.user.role === 3 && res.review_record_id) { // 判断用当前登录用户的权利
          const user_id = this.user.id // 判断用户是否有工作在进行
          const that = this
          this.$confirm({
            title: '',
            content: '您有一项初评工作正在进行，是否返回继续操作。',
            okText: '确认',
            cancelText: '取消',
            onOk() {
              that.$router.push({ path: '/admin/judgeDetail', query: { id: res.review_record_id, user_id: user_id }})
            },
            onCancel() {
            }
          })
        }
      }).catch(error => {
        console.error('获取judge首页数据失败:', error)
        this.list = []
        this.$message.error('获取数据失败，请稍后重试')
      })
    },
    goList(e) { // 跳转评奖页面，并传入作品ID
      this.$router.push({ path: '/admin/judgeList', query: { category_id: e }})
    },
    changeCate(value) { // 改变category_id并传入此id到pagekey然后再储存起来，下此请求信息会自动携带
      let pageKey = getPageKey('judgeIndex') || '{}'
      pageKey = JSON.parse(pageKey)
      pageKey.category_id = value
      setPageKey('judgeIndex', JSON.stringify(pageKey))
    }
  }
}
</script>
<style scoped>
  .searchBox {
    padding: 17px 20px;
    background: #ffffff;
  }

  .tag {
    width: 7em;
    line-height: 32px;
  }

  .table {
    margin-top: 30px;
  }

  .content {
    overflow: hidden;
    text-overflow:ellipsis;
    white-space:nowrap;
    width: 30vw;
  }
</style>
